module.exports = __webpack_public_path__ + "img/06.f11f4a4e.jpg";